// IMPORTANT NOTE: Please make sure any script imports also happen in app-tess.js

import 'babel-polyfill';
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueResource from 'vue-resource';
import SocialSharing from 'vue-social-sharing';
import Hours from './_vue/components/Hours';
import Searchpage from './_vue/components/SearchPage';

// import HeaderOnScroll from './header-on-scroll';
import HeaderNav from './header-nav';
import Alerts from './alerts';
import ScrollTeaser from './scroll-teaser';
import AutoImgDpiSrc from './auto-img-dpi-src';
import AutoImgWidthSrc from './auto-img-width-src';
import Fadable from './fadable';
import LiveClock from './live-clock';
import Videos from './videos';
// import Search from './search';
import 'slick-carousel';
import WindowResize from './window-resize';
import HandleFocus from './handle-focus';
import HandleShare from './share';
import ClickableModules from './clickable-modules';
// import Picturefill from 'picturefill';
import Ticketing from './_vue/components/Ticketing';
import HomeEventPicker from './_vue/components/HomeEventPicker';
import BlogFilter from './_vue/components/BlogFilter';
import PemcastFilter from './_vue/components/PemcastFilter';
import EventsFilter from './_vue/components/EventsFilter';
import Press from './_vue/components/Press';
import EventsHeroModal from './_vue/components/EventsHeroModal';
// Modules 2.0
import quoteSlider from './quoteSlider';
import toggles from './toggles';
import stickyNav from './sticky-nav';
import openHours from './openHours';
import featuredEventSlider from './featuredEvent';
import threeSlides from './threeSlides';
import threeCardSlider from './threeCardSlider';
import sliderCaptions from './sliderCaptions';
import VideoModal from './videoModal';
import VideoSlider from './videoSlider';
import HeroSlider from './heroSlider';
import MasonryGrid from './masonry';
import SixCardSlider from './sixCardSlider';
import SocialShare from './socialShare';
import EventsHero from './eventsHero';
import newsletter from './newsletter';

Vue.use(VueResource);

/* eslint-disable no-new */
new Vue({
	el: '#app',
	delimiters: ['${', '}'],
	mounted() {
		// Search();
		HeaderNav();
		Alerts();
		ScrollTeaser();
		AutoImgDpiSrc();
		AutoImgWidthSrc();
		Fadable();
		LiveClock();
		Videos();
		SocialShare();
		WindowResize();
		HandleFocus();
		HandleShare();
		ClickableModules();
		VideoSlider();
		HeroSlider();
		quoteSlider();
		toggles();
		stickyNav();
		openHours();
		featuredEventSlider();
		threeSlides();
		threeCardSlider();
		sliderCaptions();
		MasonryGrid();
		SixCardSlider();
		VideoModal();
		EventsHero();
		newsletter();
	},
	components: {
		hours: Hours,
		'social-sharing': SocialSharing,
		ticketing: Ticketing,
		homepicker: HomeEventPicker,
		blogfilter: BlogFilter,
		pemcastfilter: PemcastFilter,
		eventsfilter: EventsFilter,
		searchpage: Searchpage,
		press: Press,
		eventsheromodal: EventsHeroModal,
	},
});
